import { FC } from 'react';
import { RootState } from '@/reducers';
import { useTranslation } from 'react-i18next';
import { setSearchText } from '@/features/dataSources/dataSourcesSlice';
import { SearchInput } from '@/global/components';

export const DataSourcesTableSearch: FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex justify-end'>
      <SearchInput
        wrapperClassName='p-4 rounded-md h-auto'
        stateSelector={(state: RootState) => state.dataSources.ui.searchText}
        stateUpdater={setSearchText}
        placeholder={t('COMMON:searchByName')}
      />
    </div>
  );
};
